import { throttle } from 'lodash-es';
import { USER_LEVEL_KEY, type IEquity } from '~/api/interface';
import { getRightsView } from '~/pages/subscribe/components/rights-view';
import Rights3 from '~/pages/subscribe/components/rights-view/rights-3';
import Rights10 from '~/pages/subscribe/components/rights-view/rights-10';
import Rights16 from '~/pages/subscribe/components/rights-view/rights-16';
import Rights24 from '~/pages/subscribe/components/rights-view/rights-24';

export const useUpgrade = throttle(async (type: 'upgrade' | 'renew' = 'upgrade') => {
  const userInfo = useUserInfo();
  const accountList = useAccountList();
  const rightsConfig = useRightsConfig();
  const rights = await useDisplayRights();

  const UpgradeMap = {
    [USER_LEVEL_KEY.TASTE]: USER_LEVEL_KEY.PERSONAL,
    [USER_LEVEL_KEY.PERSONAL_LITE]: USER_LEVEL_KEY.PERSONAL_LITE,
    [USER_LEVEL_KEY.TEAM_TASTE]: USER_LEVEL_KEY.TEAM_LIGHT,
    [USER_LEVEL_KEY.PERSONAL]: USER_LEVEL_KEY.PERSONAL,
    [USER_LEVEL_KEY.TEAM_LIGHT]: USER_LEVEL_KEY.TEAM_LIGHT,
    [USER_LEVEL_KEY.ORG_STANDARD]: USER_LEVEL_KEY.ORG_STANDARD,
    [USER_LEVEL_KEY.ORG_FLAGSHIP]: USER_LEVEL_KEY.ORG_FLAGSHIP,
  };

  const UpgradeableKey = Object.keys(UpgradeMap).map(Number);

  let r: IEquity | undefined;

  if (UpgradeableKey.includes(userInfo.value!.rights_type)) {
    r = rights.value?.rights.find(
      v =>
        v.rights_type ===
        (type === 'upgrade' ? UpgradeMap[userInfo.value!.rights_type] : userInfo.value!.rights_type)
    );
  }

  if (r) {
    const rightsView = getRightsView({
      rights: r,
      userInfo: userInfo.value!,
      accountList: accountList.value,
      overseas: isGlobalVersion() ? rightsConfig.value : null,
    });

    const isGlobal = isGlobalVersion();

    if (rightsView instanceof Rights3) {
      rightsView.newOrder(isGlobal ? 'monthly' : undefined);
    }

    if (rightsView instanceof Rights10) {
      rightsView.newOrder(isGlobal ? 'monthly' : undefined);
    }

    if (rightsView instanceof Rights16) {
      // rightsView.newOrder()
      rightsView.openContact(getQrcodeURI('b', '23'));
    }

    if (rightsView instanceof Rights24) {
      rightsView.openContact(getQrcodeURI('b', '23'));
    }
  }
}, 500);
